import React, { useEffect, useState } from 'react';

//Header Data

import styles from '../Profile.module.scss';

import { Award, User } from '../../../global';

import { AwardRow } from '../../../components/AwardRow/AwardRow';
import { NoContent } from '../../../components/Reusable/NoContent';
import axiosHelper from '../../../helpers/axiosHelper';
import useSWR from 'swr';
import ProfileColumn from './components/ProfileColumn';

interface Props {
  user: User;
  loggedUser: User | null;
  breadcrumbs: (breadcrumbs: string) => void;
  setPopupMessage: (e: boolean) => void;
}

const AwardsWLF: React.FC<Props> = ({ user, loggedUser, breadcrumbs, setPopupMessage }) => {
  const { data, error, isLoading } = useSWR('awuid|' + user.id, axiosHelper.awardsFetcher);

  const [awards, setAwards] = useState<Award[]>([]);
  useEffect(() => {
    if (data) {
      setAwards(data.awards);
    }
  }, [data]);

  useEffect(() => {
    breadcrumbs('Awards');
  }, []);


  return (
    <div className="bg-light-gray">
      <main className={`${styles.profileWrapper} container pt-5 mb-5 px-sm-0 overflow-hidden`}>
        <div className={`row    `}>
          {/* Left column  ====================================================== */}
          <ProfileColumn user={user} />
          <div className="col-12 col-md-9  ps-5 ps-sm-4">
            {awards && awards.length > 0 ? (
              awards?.map((anAward: Award, index: number) => (
                <div key={index} className="row mb-4 mx-0">
                  <AwardRow award={anAward} show='contest'/>
                </div>
              ))
            ) : (
              <NoContent />
            )}
          </div>
          {/* <div className="row mt-3 px-4"></div> */}
        </div>
      </main>
      {/* <AppFooter links={footerMenu} bgColor="#304053" logoImg={headerLogo} bgImage={footerImg} /> */}
    </div>
  );
};
export default AwardsWLF;
